import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Col, Row } from 'reactstrap';
export const ModalPreViewMedicalOrder = (props) => {

    const {
        modal, toggle, workMedicalOrderPDF, typeModal = "view",
    } = props;

    return (
        <Modal isOpen={modal} toggle={toggle} backdrop='static' keyboard={false} centered={true} className="modal-xl" >
            <ModalHeader toggle={toggle} className="bg-primary">
                Previsualizar PDF
            </ModalHeader>
            {
                typeModal === "view" ?
                    <ModalBody>
                        {
                            <div>
                                <Col sm="12">
                                    <embed src={'data:application/pdf;base64,' + workMedicalOrderPDF} title="Previsualizador" type="application/pdf" width="100%" height="600px" />
                                </Col>

                            </div>
                        }
                    </ModalBody>
                    : ""
            }
            <ModalFooter>
            </ModalFooter>

        </Modal>
    )
}